<template>
    <transition name="modal" v-if="visible">
        <div class="custom-modal-mask">
            <div class="custom-modal-wrapper">
                <div class="custom-modal-container" v-click-outside="hide">
                    <div class="custom-modal-header">
                        <slot name="header">
                            <h5>Thông báo</h5>
                        </slot>
                    </div>

                    <div class="custom-modal-body">
                        <slot name="body">
                            {{content}}
                            <div class="pb-3 pr-0 form-group mt-2">
                                <label class="col-md-12 pl-0 pr-0 pt-1 col-sm-3 control-label text-left mb-0 font-weight-bold">Lí do<span style="color:red;">*</span>:</label>
                                <input type="text"
                                       class="form-control input-vxr"
                                       placeholder="Lí do"
                                       v-model.trim="$v.reason.$model">
                                <div v-if="$v.reason.$error">
                                    <span class="error" v-if="!$v.reason.required">Lí do không được để trống</span>
                                </div>
                            </div>
                        </slot>
                    </div>

                    <div class="custom-modal-footer">
                        <slot name="footer">
                            <button class="custom-modal-default-button btn btn-sm btn-primary" @click.stop="confirm">
                                OK
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import required from 'vuelidate/lib/validators/required';
    import { ModalRejectConfirmPlugin } from '../../../plugins';
    import {MixinHelper} from "../services";
    import {RepositoryFactory} from "../services";
    import { eventBus } from '../services';

    const repo = RepositoryFactory.get('orders');

    export default {
        name: "CustomModalRejectConfirm",
        mixins: [MixinHelper],
        beforeMount() {
            ModalRejectConfirmPlugin.EventBus.$on('show', (params) => {
                this.show(params);
            });
            ModalRejectConfirmPlugin.EventBus.$on('hide', () => {
                this.hide();
            })
        },
        data() {
            return {
                reason: '',
                content: '',
                visible: false,
                onConfirm: {},
                order_id: 0
            }
        },
        validations: {
            reason: {
                required
            }
        },
        methods: {
            confirm() {
                this.$v.$touch();
                if (this.$v.$error) {
                    return;
                }
                repo.reject(this.order_id, this.reason)
                    .then(resp => {
                        this.hide();
                        const self = this;
                        setTimeout(function () {
                            self.$modalNotify.show({...{}, content: 'Thành công'});
                        }, 500);
                        eventBus.$emit('reject-order', this.getProp(resp, 'data.data', {}));
                    })
                    .catch(err => {
                        this.hide();
                        this.$modalNotify.show({...{}, content: 'Thất bại'});
                    })
            },
            show(params) {
                this.content = this.getProp(params, 'content', 'Bạn có chắc chắn muốn hủy ?');
                this.order_id = this.getProp(params, 'order_id', {});
                this.visible = true;
            },
            hide() {
                this.visible = false;
            }
        }
    }
</script>

<style scoped>

</style>
